/**
 * Safely extracts error message from various error formats
 * Handles validation error objects with {type, loc, msg, input, url} structure
 */
export const getErrorMessage = (error: any, defaultMessage = 'Došlo k neočekávané chybě'): string => {
  // Handle null/undefined/falsy values
  if (!error) {
    return defaultMessage;
  }

  // If it's already a string, return it
  if (typeof error === 'string') {
    return error;
  }

  // If it's an Error object, get the message
  if (error instanceof Error) {
    return error.message;
  }

  // If it's an axios error, try to extract the detail
  if (error?.response?.data?.detail) {
    const detail = error.response.data.detail;
    
    // If detail is a string, return it
    if (typeof detail === 'string') {
      return detail;
    }
    
    // If detail is a validation error object, extract the message
    if (detail?.msg && typeof detail.msg === 'string') {
      return detail.msg;
    }
    
    // If detail is an array of validation errors, extract the first message
    if (Array.isArray(detail) && detail.length > 0 && detail[0]?.msg) {
      return detail[0].msg;
    }
    
    // If it's an object, try to stringify it
    if (typeof detail === 'object') {
      try {
        return JSON.stringify(detail);
      } catch {
        return defaultMessage;
      }
    }
  }

  // If it's a validation error object directly
  if (error?.msg && typeof error.msg === 'string') {
    return error.msg;
  }

  // If it's an array of validation errors
  if (Array.isArray(error) && error.length > 0 && error[0]?.msg) {
    return error[0].msg;
  }

  // Last resort: stringify if it's an object
  if (typeof error === 'object') {
    try {
      return JSON.stringify(error);
    } catch {
      return defaultMessage;
    }
  }

  return defaultMessage;
};